module.exports = __webpack_public_path__ + "static/media/check-badge.f425db60.svg";